
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post131() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Bom dia Gente
Eu fui no Cardiologista
Ele disse que 125 ainda é Pré diabetes e tem como reverter comendo frutas, verduras, comidas integral e tirando açúcar que volta o normal
</title>
        <meta 
          name="description" 
          content="Bom dia Gente
Eu fui no Cardiologista
Ele disse que 125 ainda é Pré diabetes e tem como reverter comendo frutas, verduras, comidas integral e tirando açúcar que volta o normal
"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Georgina Klar &#183; 19/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Bom dia Gente<br/>Eu fui no Cardiologista<br/>Ele disse que 125 ainda é Pré diabetes e tem como reverter comendo frutas, verduras, comidas integral e tirando açúcar que volta o normal<br/>
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/131')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  4 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Bom dia, Georgina!<br/><br/>Fico feliz que você esteja buscando informações para cuidar bem da sua saúde! Seu cardiologista está certo; com algumas mudanças na alimentação e no estilo de vida, é possível sim reduzir os níveis de açúcar no sangue e, quem sabe, evitar que a pré-diabetes se desenvolva em diabetes.<br/><br/>Aqui vão algumas dicas simples que podem te ajudar nesse processo:<br/>1. **Frutas e Verduras:** Inclua uma grande variedade de frutas e verduras nas suas refeições. Elas são ricas em fibras, vitaminas e minerais.<br/>2. **Comidas Integrais:** Opte por alimentos integrais como arroz integral, pão integral e aveia. Eles ajudam a manter os níveis de açúcar no sangue mais estáveis.<br/>3. **Reduzir o Açúcar:** Tente diminuir ao máximo o consumo de açúcares e alimentos processados. Pode ser difícil no começo, mas aos poucos você vai acostumando.<br/><br/>Além desses pontos, lembre-se de praticar alguma atividade física regularmente. Pode ser uma caminhada, dança, ou qualquer outra atividade que você goste.<br/><br/>Continue seguindo as orientações do seu cardiologista e qualquer dúvida a mais, estamos aqui para ajudar!<br/><br/>Abraços,<br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 19/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/131')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Tami Costa &#183; 22/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/3-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Compartilhando sua vida com uma doença crônica - recomendação de livro  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Há alguns meses, pesquisando livros sobre doenças crônicas, recebi a recomendação do livro Pain Woman Takes Your Keys, and Other Essays from a Nervous System (infelizmente sem versão em português ao meu conhecimento). Diferentemente do que estava procurando, que seria um livro de informações e fatos sobre doenças crônicas, estilo livro acadêmico, Pain Woman é um livro que relata de forma íntima e direta a experiência de desenvolver uma doença crônica, e se deparar que você vai dividir o resto de sua vida com ela. Que o resultado disso é um novo você.<br/><br/>A autora do livro, Sonya Huber, relata através de uma série de textos curtos (ou essays) sua experiência desde a aparição da doença artrite reumatóide, do seu desenvolvimento e de todo impacto que ela teve em sua vida. Ela descreve as dificuldades emocionais e sociais que isso causou, sua revolta e por fim o seu entendimento dessa nova companheira que agora era parte de si mesma.<br/><br/>O livro é bastante pessoal e nos faz conhecer Sonya e nos tornarmos de alguma forma seu amigo, da Sonya pré-artrite reumatóide e pós-artrite reumatóide. Bastante intenso e expressivo, é um dos melhores relatos que conheço do que é viver com uma doença crônica, e recomendo para todos que querem conhecer essa realidade, para lidar com a sua própria ou para melhor empatizar com alguém que está passando por isso a sua volta.
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/3')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        Nenhum comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Bruna Almeida &#183; 16/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/112-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal boa tarde minha hemoglobina glicada deu 13.5, ta muito alta?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/112')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    T. Estudante &#183; 23/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/5-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Experiência lidando com diabetes  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Quando fui diagnosticado com diabetes, já uns 8 anos atrás, meu primeiro sentimento foi de revolta. Porque eu?, eu pensava. Nem muito acima do peso eu estava. Porém com o tempo fui aceitando e aprendendo a viver com essa nova realidade. No fim, diabetes mudou minha vida e a forma como eu vivo. E apesar da minha revolta inicial, a maioria dessas mudanças foi para o bem. Pensando a respeito, resolvi escrever algumas coisas que aprendi desde meu diagnóstico e que talvez sejam úteis para outras pessoas.<br/><br/>Já vou começar pelo mais importante: a primeira coisa que aprendi foi que nenhum tratamento para diabetes funciona sozinho. Diabetes, talvez mais que qualquer outra doença crônica, precisa ser gerenciada pelo paciente, porque quase qualquer coisa que nós fazemos tem um efeito no nosso nível de glicose no sangue.<br/><br/>Para diabetes não tem uma pílula milagrosa que o médico vai receitar, nós (quem tem diabetes) precisa participar ATIVAMENTE do tratamento, tomando controle da nossa saúde, estudando e aprendendo sobre a doença. <br/><br/>Isso é muito trabalhoso, mas recompensador, porque mostra o nosso poder em controlar e influenciar (pelo menos parcialmente) a nossa saúde.<br/><br/>A melhor coisa que fiz logo no início, e recomendo para quem tem diabetes, é comprar um medidor de glicose, aprender a utilizar o aparelho, e medir a glicose todos os dias (e no início, mais de uma vez ao dia). Isso foi super importante para aprender como meu nível de glicose funciona, e como as coisas que afetam ele (diferentes comidas, diferentes rotinas de exercício físico). Depois de um ano fazendo isso, eu já tinha uma boa ideia de como meu corpo e meu nível de glicose respondiam aos vários estímulos, e não precisei mais medir com tanta frequência. <br/><br/>O segundo ponto importante é a alimentação. Não vou falar de dieta diretamente, porque imagino que seja diferente para cada pessoa, mas limitar a quantidade de comida foi uma das coisas mais importantes que fiz: me ajudou chegar no peso ideal e ter mais energia e disposição. Uma coisa posso falar com segurança: o controle de diabetes se beneficia da redução de calorias ingeridas, e fiz isso principalmente trocando outras carnes por peixe e aumentando a quantidade de vegetais no meu prato.<br/><br/>Depois de colocar a alimentação em ordem, a terceira coisa mais importante que fiz foi começar a me exercitar. O truque aqui foi encontrar uma maneira de fazer exercício ser algo que eu gostava. Para mim, o que funcionou foi começar a fazer natação, algo que eu sempre tinha vontade de fazer, mas nunca tinha começado. A diabetes foi o catalisador para isso, e hoje todas as semanas, gosto muito e me faz muito bem.<br/><br/>Espero que essa minha experiência sirva e possa dar algumas ideias para quem está começando a enfrentar essa situação agora. Com controle e esforço, é possível viver com uma qualidade de vida ainda melhor do que antes da diabetes!!
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/5')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Neila Gabler &#183; 07/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/32-colesterol" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    E a visão pessoal, sentiram que piorou com o aparecimento do colesterol?? Eu estou passando por isso infelizmente!! Oque vocês fizeram?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/32')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Martina Coelho &#183; 13/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/86-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal<br/>Fui diagnosticada com câncer de mama há 1 semana, e estou sem chão, parece que o mundo perdeu o sentido…<br/>Confesso que minha vontade é só de ficar deitada na cama, no escuro, sozinha...<br/>Estou desde o dia do diagnóstico sem trabalhar, amanhã terei q voltar, mas só em pensar que terei q encarar os olhos das pessoas me olhando com dó, me já me dá uma ansiedade
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/86')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            5 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
